import React, { Fragment, useEffect, useState } from "react";
import Parser from "../../parser";
import { queryHandler } from "./productQueries";
import handleClassNames from "../../../utils/handleClassNames";
const visibilityToLayout = (visibility) => {
    const output = [];
    if (!visibility) {
        return output;
    }
    Object.entries(visibility).forEach(([key, value]) => {
        if (value && key !== "orderBy") {
            output.push(["woocommerce/product-" + key]);
        }
    });
    return output;
};
const Product = (props) => {
    const layout = props.attributes.layoutConfig ||
        visibilityToLayout(props.attributes.contentVisibility);
    return (React.createElement(Parser, { structure: layout.map((oldBlock) => {
            const block = {};
            block.name = oldBlock[0];
            const attr = { ...(props.attributes || {}) };
            delete attr.className;
            delete attr.contentVisibility;
            delete attr.products;
            block.attributes = { ...attr, ...(oldBlock[1] || {}) };
            block.product = props.product;
            return handleClassNames(block);
        }) }));
};
const Products = ({ products, attributes }) => {
    if (!products || !products.length) {
        return React.createElement(React.Fragment, null);
    }
    console.log(products, attributes);
    //trier les trucs en fonction de contentVisibility.orderBy si ça existe
    return (React.createElement("div", { className: attributes.className }, products.map((product) => {
        return (React.createElement(Product, { key: product.id, product: product, attributes: attributes }));
    })));
};
export default Products;
